export const IATA_DIVISOR = 6000;

export default {
    IATA_DIVISOR,
};
